import $ from 'jquery'

const scrollingSpeedRatio = 0.7

const horizontalScroll = {
  init(root = document) {
    const $root = $(root)

    if ($root.find('.horizontal-scroll-component').length === 0) {
      return
    }

    horizontalScroll.scrollNavInit($root)

    $root.find('.horizontal-scroll-component .scroll-parent').each(function () {
      let parent = '#' + $(this).attr('id')
      let element = parent + ' .scroll-horizontal'

      horizontalScroll.setDataRegion(parent, element)
      horizontalScroll.setDataHasScrollbar(parent, element)

      $(element).on('scroll.horizontalScroll', function () {
        horizontalScroll.setDataRegion(parent, element)
      })
    })

    $(window).on('resize.horizontalScroll', function () {
      $root.find('.horizontal-scroll-component .scroll-parent').each(function () {
        let parent = '#' + $(this).attr('id')
        let element = parent + ' .scroll-horizontal'

        horizontalScroll.setDataHasScrollbar(parent, element)
      })
    })
  },

  destroy() {
    $(window).off('.horizontalScroll')
    $('.scroll-horizontal').off('.horizontalScroll')
    $('.scroll-nav').off('.horizontalScroll')
  },

  scrollNavInit($root) {
    const $targets = $root.find(
      '.horizontal-scroll-component .scroll-parent .scroll-nav'
    )

    $targets.off('click.horizontalScroll')

    $targets.on('click.horizontalScroll', function (e) {
      e.preventDefault()

      let $navButton = $(this).find('.scroll-nav-btn')
      const multipleNavButtons =
        $(this).find('.scroll-nav-btn').length > 1

      if (multipleNavButtons) {
        $navButton = $(e.target).closest('.scroll-nav-btn')
      }

      var scrollParent = $navButton.attr('data-scroll-parent');
      var scrollTarget = scrollParent + ' .scroll-horizontal';

      var targetEl = document.querySelector(scrollTarget);

      var distance = targetEl
        ? targetEl.clientWidth
        : 300;

      var currentPosition = horizontalScroll.getPosition(scrollTarget);

      $(scrollTarget).animate({
        scrollLeft:
          $navButton.attr('data-direction') === 'right'
            ? currentPosition + distance
            : currentPosition - distance,
      })
    })
  },

  getPosition(element) {
    return $(element).scrollLeft()
  },

  getMaxScroll(element) {
    const el = document.querySelector(element)

    return el.scrollWidth - (el.clientWidth + 10)
  },

  setDataRegion(parent, element) {
    let maxScroll = horizontalScroll.getMaxScroll(element)
    let currentPosition = horizontalScroll.getPosition(element)

    if (currentPosition === 0 && maxScroll < 0) {
      $(parent).attr('data-scroll-region', 'min')
    } else if (currentPosition >= maxScroll) {
      $(parent).attr('data-scroll-region', 'max')
    } else if (currentPosition === 0) {
      $(parent).attr('data-scroll-region', 'min')
    } else {
      $(parent).attr('data-scroll-region', 'middle')
    }
  },

  setDataHasScrollbar(parent, element) {
    if (
      horizontalScroll.getPosition(element) === 0 &&
      horizontalScroll.getMaxScroll(element) <= 0
    ) {
      $(parent).attr('data-has-scrollbar', 'false')
    } else {
      $(parent).attr('data-has-scrollbar', 'true')
    }
  },
}

export default horizontalScroll